import { IRootState } from '../../../store'
import { ISpecialReportsState } from '../store/specialReports.types'

export const getSpecialReportsSelector = (state: IRootState): ISpecialReportsState => state.specialReports
